/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const headerAccountItemSX: SxProps = {
	p: 2,
};

export const headerAccountLinkSX: SxProps = {
	'&:hover': {
		color: 'primary.main',
	},
	fontSize: 'var(--font-size-small)',
};
